import React from 'react'
import Progress from './Progress'
import { Button } from '../../lib/ui/button'
import { useTranslation } from '../../hooks/useTranslation'
import { useQuiz } from './QuizProvider'

const Quiz = ({ progressTotal, children }) => {
  // const questionsArr = Object.values(questionsInfo)
  const { quizIndex, formattedQuizName, saveQuiz, quizPartId } = useQuiz()
  const { t } = useTranslation(formattedQuizName)
  const { t: tc } = useTranslation('')
  const questionsInfo = t('questions')
  const questionsArr = Object.values(questionsInfo)
  const numQuestions = progressTotal || questionsArr.length

  const handleLeavePage = () => {
    localStorage.removeItem(`${quizPartId}:started`)
    localStorage.removeItem(`${quizPartId}:results`)
    localStorage.removeItem('idx')
    saveQuiz()
  }

  return (
    <div className="container flex flex-col">
      <div className="flex">
        <Progress current={quizIndex} total={numQuestions} />
        <Button
          className="flex items-start self-start bg-transparent p-0 text-black hover:bg-transparent hover:text-gray-500"
          title={tc('save_and_finish_later', 'Save and finish later')}
          onClick={handleLeavePage}
        >
          <i className="el-icon-remove-circle"></i>
        </Button>
      </div>
      {children}
    </div>
  )
}
export default Quiz
